import { jsx as _jsx } from 'react/jsx-runtime.js';
import { CardContent } from '@stepstone-genesis/components';
import { useAppSelector } from '../../../redux/hooks.js';
import { activeViewSelector, isFullscreenSelector, } from '../../../redux/core/wrapperContext/wrapperContextSlice.js';
import { stepModalFormConfigs } from '../../../redux/wrappers/StepModal/stepModalFormConfigs.js';
import { FadeTransition } from '../../common/transitions/index.js';
export const RightSideContent = () => {
    const activeView = useAppSelector(activeViewSelector);
    const stepModalForms = stepModalFormConfigs();
    const activeFormConfig = stepModalForms.find(({ type }) => type === activeView);
    const ViewComponent = activeFormConfig?.component;
    const isFullscreen = useAppSelector(isFullscreenSelector);
    if (!ViewComponent || !activeView) {
        return null;
    }
    return (_jsx(CardContent, { sx: {
            width: ['100%', '51.5%'],
            flex: 1,
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'center',
        }, pt: ['spaceM', 'spaceL'], children: _jsx(FadeTransition, { transitionKey: activeView, sx: {
                flex: 1,
                flexDirection: 'column',
                display: 'flex',
                alignItems: 'stretch',
                justifyContent: 'center',
                maxWidth: `${isFullscreen ? '456px' : '100%'}`,
            }, children: _jsx(ViewComponent, {}) }) }));
};
//# sourceMappingURL=RightSideContent.js.map